import { cn } from "@/lib/chillnn/cn";

import { SwitchField } from "@/components/ui/form/fields/switch-field";

import type { RoomPriceRankItemType } from "../../../../../type";

type Props = {
	priceRankItem: RoomPriceRankItemType;

	onSetIsStopSelling: (input: boolean | undefined) => void;
};

export const RoomPriceRankStopSell = ({ priceRankItem, onSetIsStopSelling }: Props) => {
	return (
		<div className="space-y-2">
			<div className="mb-4 space-y-1">
				<h4 className="text-lg font-semibold">売止設定</h4>

				<p className="text-sm ">
					ステータスが "売止"
					になっていると、部屋料金を設定している場合やカレンダーで色を塗っている場合でも売り止めになります。
				</p>
			</div>
			<div className="ml-4">
				<SwitchField
					value={!priceRankItem.isStopSelling?.value || false}
					handleInput={onSetIsStopSelling}
					errorMessage={priceRankItem.isStopSelling?.error}
				/>
				<div className="flex items-center gap-x-2 text-xs">
					<p
						className={cn(
							priceRankItem.isStopSelling?.value
								? "font-semibold text-error-600"
								: "font-normal text-zinc-300",
						)}
					>
						売止
					</p>
					<p> / </p>
					<p
						className={cn(
							priceRankItem.isStopSelling?.value ? "font-normal text-zinc-300" : "font-semibold",
						)}
					>
						販売中
					</p>
				</div>
			</div>
		</div>
	);
};

RoomPriceRankStopSell.displayName = "RoomPriceRankStopSell";
